/* eslint-disable import/no-anonymous-default-export */
import { ExpensesClaimList } from './list/ExpensesClaimList';
import { ExpensesClaimShow } from './show/ExpensesClaimShow';
import { ExpensesClaimSummary } from '@wwf/sdk';

export default {
    list: ExpensesClaimList,
    show: ExpensesClaimShow,
    recordRepresentation: (record: ExpensesClaimSummary) =>
        record.name ?? `${record.id}`,
};
